import React from "react";
import Contact from "../components/Contact/Contact.jsx";

const ContactPage = () => {
  return (
    <div>
      <Contact />
    </div>
  );
};

export default ContactPage;
